import { createSlice } from '@reduxjs/toolkit';

export const spinSlice = createSlice(
  {
    name: 'spin',
    initialState: {
      loading: false
    },
    reducers: {
      loading: (state, action) => {
        state.loading = action.payload;
      }
    }
  }
);

export default spinSlice.reducer;
export const { loading } = spinSlice.actions;
export const selectSpin = state => state.spin.loading;
